import { Alert, Button, Group, Stack, Text } from '@mantine/core'
import { useSidebarShift } from '@/lib/shift-context'

/**
 * Крупное напоминание: при активном перерыве работа с обращениями должна сопровождаться
 * завершением перерыва (кнопка в шапке или здесь).
 */
export function OnBreakWorkBanner() {
  const { isOnBreak, busy, toggleBreak, breakLabel } = useSidebarShift()
  if (!isOnBreak) return null

  return (
    <Alert
      color="orange"
      variant="filled"
      radius="md"
      p="md"
      title="У вас включён перерыв"
      styles={{
        root: { alignItems: 'flex-start' },
        title: {
          marginBottom: 6,
          fontSize: 'var(--mantine-font-size-xl)',
          fontWeight: 800,
          lineHeight: 1.25,
          color: 'var(--mantine-color-white)',
        },
        message: { width: '100%' },
      }}
    >
      <Stack gap="sm">
        <Text size="md" c="var(--mantine-color-white)" lh={1.45} style={{ opacity: 0.95 }}>
          Если вы начали работу с обращением (ответ или решение), завершите перерыв — так корректнее
          учитывается смена.
        </Text>
        <Group justify="flex-end" wrap="wrap" gap="xs">
          <Button
            variant="white"
            color="orange"
            size="md"
            fw={600}
            onClick={() => void toggleBreak()}
            loading={busy}
          >
            {breakLabel}
          </Button>
        </Group>
      </Stack>
    </Alert>
  )
}
